// DEPENDENCIES
import React from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';
import Button from './Button';

const ActionBlock = (props) => {

    const sizes = {
        sm: "small",
        default: ""
    }

    return (
        <>
            {
                props.fullAction ?
                    <Link
                        className={`action-block-container ${props.className ? props.className : ""}`}
                        to={props.to ? props.to : "/"}
                        onClick={props.onClick ? props.onClick : () => { }}
                    >

                    </Link>
                    :
                    <CustomBlock className={`action-block-container ${props.className ? props.className : ""} ${props.size ? sizes[props.size] : ""} ${props.backgroundColor ? props.backgroundColor : "lighter--bg"}`}>
                        {
                            props.toggleIconPosition == 'left' &&
                            <CustomBlock className="toggle-icon-container left">
                                <Link
                                    className={`toggle-icon ${props.toggleIconBackground ? props.toggleIconBackground : "light-grey--bg"}`}
                                    to={props.toggleIconTo ? props.toggleIconTo : "#"}
                                    onClick={props.toggleIconOnClick ? props.toggleIconOnClick : () => { }}
                                >
                                    {props.toggleIcon}
                                </Link>
                            </CustomBlock>
                        }

                        {
                            props.actionsPosition == 'left' &&
                                <CustomBlock className="actions-container left">
                                    {
                                        props.primaryActionText, props.primaryActionBackground &&
                                        <Button
                                            text={props.primaryActionText}
                                            className={` ${props.primaryActionBackground}`}
                                            to={props.primaryActionTo ? props.primaryActionTo : "#"}
                                            onClick={props.primaryActionOnClick ? props.primaryActionOnClick : () => { }}
                                            size="xs"
                                        />
                                    }

                                    {
                                        props.secondaryActionText, props.secondaryActionBackground &&
                                        <Button
                                            text={props.secondaryActionText}
                                            className={` ${props.secondaryActionBackground}`}
                                            to={props.secondaryActionTo ? props.secondaryActionTo : "#"}
                                            onClick={props.secondaryActionOnClick ? props.secondaryActionOnClick : () => { }}
                                            size="xs"
                                        />
                                    }
                                </CustomBlock>
                        }

                        <CustomBlock className="text-container">
                            <p className="title">
                                {props.title}
                            </p>
                        </CustomBlock>

                        {
                            props.toggleIconPosition == 'right' &&
                            <CustomBlock className="toggle-icon-container right">
                                <Link
                                    className={`toggle-icon ${props.toggleIconBackground ? props.toggleIconBackground : "light-grey--bg"}`}
                                    to={props.toggleIconTo ? props.toggleIconTo : "#"}
                                    onClick={props.toggleIconOnClick ? props.toggleIconOnClick : () => { }}
                                >
                                    {props.toggleIcon}
                                </Link>
                            </CustomBlock>
                        }

                        {
                            props.actionsPosition == 'right' &&
                            <CustomBlock className="actions-container right">
                                {
                                    props.primaryActionText, props.primaryActionBackground &&
                                    <Button
                                        text={props.primaryActionText}
                                        className={` ${props.primaryActionBackground}`}
                                        to={props.primaryActionTo ? props.primaryActionTo : "#"}
                                        onClick={props.primaryActionOnClick ? props.primaryActionOnClick : () => { }}
                                        size="xs"
                                    />
                                }

                                {
                                    props.secondaryActionText, props.secondaryActionBackground &&
                                    <Button
                                        text={props.secondaryActionText}
                                        className={` ${props.secondaryActionBackground}`}
                                        to={props.secondaryActionTo ? props.secondaryActionTo : "#"}
                                        onClick={props.secondaryActionOnClick ? props.secondaryActionOnClick : () => { }}
                                        size="xs"
                                    />
                                }
                            </CustomBlock>
                        }
                    </CustomBlock>
            }
        </>
    );
}

export default ActionBlock;